import { useEffect } from 'react'
import { List, Button, Input } from 'antd'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import FormLikeField from './FormLikeField'

RadioOptionsConfig = ({ fieldKey }) ->

  initial = [
    { label: 'Yes', value: true }
    { label: 'No', value: false }
  ]

  [{ fieldData }, dispatch] = useCreateMacroData()

  useEffect( ->
    unless fieldData[fieldKey].options
      dispatch(
        setFieldData(
          _.set(fieldData, [fieldKey, 'options'], initial)
        )
      )
  , [])

  setRadioOptions = (i, prop, value) ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, 'options', i, prop], value)
      )
    )

  addRadioOption = ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, 'options'],
          fieldData[fieldKey].options.concat([{ label: 'label', value: 'value' }])
        )
      )
    )

  removeRadioOption = (i) ->
    fieldData[fieldKey].options.splice(i, 1)
    dispatch(
      setFieldData(fieldData)
    )

  <FormLikeField label="Radio options" key="#{fieldKey}-options-config">
    <div style={{ paddingBottom: 20 }} className="relation-through-rules">
      <List
        bordered
        dataSource={fieldData[fieldKey]?.options}
        locale={{ emptyText: 'No rules' }}
        renderItem={(item, i) -> (
          <List.Item
            actions={[
              <FormLikeField label="Label">
                <Input
                  placeholder="Label"
                  style={{ display: 'inline' }}
                  value={item.label}
                  onChange={({ target: { value }}) -> setRadioOptions(i, 'label', value)}
                />
              </FormLikeField>,
              <FormLikeField label="Value">
                <Input
                  placeholder="Value"
                  style={{ display: 'inline' }}
                  value={item.value}
                  onChange={({ target: { value }}) -> setRadioOptions(i, 'value', value)}
                />
              </FormLikeField>,
              <Button
                onClick={ -> removeRadioOption(i)}
                icon={<CloseOutlined />}
                type='link'
                danger
              />
            ]}
          />
        )}
      />
      <Button
        type="link"
        style={{ float: 'right', margin: '10px 0' }}
        icon={<PlusOutlined />}
        onClick={addRadioOption}
      >Add new option</Button>
    </div>
  </FormLikeField>

export default RadioOptionsConfig